import { useState } from 'react';
import { FcSearch } from "react-icons/fc";
import Hours from '../components/Hours';
import Days from '../components/Days';
import OriginButton from '../components/OriginButton';
import TimeInterval from '../components/TimeInterval';
import LoadingSpinner from '../components/LoadingSpinner';
import './Home.css';

const Home = ({ data, sectionChangeHandler, city, dataOriginName, dataOriginChange, isLoading }) => {
    const [timeInterval, setTimeInterval] = useState('hours');

    const date = new Date();
    const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
    const dateString = date.toLocaleDateString("es-ES", options);

    const changeTimeInterval = ( interval ) => {
        setTimeInterval(interval);
    }

    const ErrorMessage = () => (
        <div className="error__container">
            <h2 className="error__title">Vaya, ha ocurrido el siguiente error:</h2>
            <p className="error__message">{data.error}</p>
        </div>
    )

    const WeatherLastUpdate = ({ lastUpdateTime }) => (
        <div className="home__weather-last-update">Últ. Actualización: {lastUpdateTime}</div>
    )

    return (
        <>
            <header>
                <div className="home-header__data">
                    <div>
                        <h1 className="home-header__city">{city}</h1>
                        <p className="home-header__date">{dateString}</p>
                    </div>
                    <div className="home-header__temp">
                        {data?.current && `${data.current.temp}º`}
                    </div>
                    <button className="home-header__search-icon" onClick={() => sectionChangeHandler('search')}>
                        <FcSearch />
                    </button>
                </div>
                <TimeInterval clickHandler={changeTimeInterval} />
            </header>
            <main className="home-main">
                {data?.current?.lastUpdate && <WeatherLastUpdate lastUpdateTime={data.current.lastUpdate} />}
                {!data && <LoadingSpinner />}
                {data?.error && <ErrorMessage />}
                {(data?.hourly && !isLoading && timeInterval === 'hours') && <Hours data={data} dataOriginName={dataOriginName} />}
                {(data?.daily && !isLoading && timeInterval === 'days') && <Days data={data} dataOriginName={dataOriginName} /> }
            </main>
            <OriginButton dataOriginName={dataOriginName} dataOriginChange={dataOriginChange} />
        </>
    );
}
  
export default Home;